import { SetLeftIcon } from './SetLeftIcon';

/**
 * author: Simran
 * id FB4645C1-DF04-49E0-BA0B-7C02C87AF3A9
 * name set-left
 * version: 1.9.32
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/set-left.svg
 * tags
 * - Database 
 */
export const DifferenceLeftIcon = SetLeftIcon;
export default DifferenceLeftIcon